import { render } from "./HeaderMock.vue?vue&type=template&id=2ac89d2c&scoped=true"
import script from "./HeaderMock.vue?vue&type=script&lang=js"
export * from "./HeaderMock.vue?vue&type=script&lang=js"

import "./HeaderMock.vue?vue&type=style&index=0&id=2ac89d2c&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac89d2c"]])

export default __exports__